import React, { Component } from "react";
import { Route } from "react-router-dom";
import LeftSidebar from "../../component/admin/LeftSidebar";
import TopHeader from "../../component/admin/TopHeader";
import Footer from "../../component/admin/Footer";
import "../../assets/scss/app.scss";
class AdminDashboard extends Component {
  render() {
    return (
      <div className="fixed-left">
        <div id="wrapper">
          <Route component={LeftSidebar} />
          <div className="content-page">
            <div className="content">
              <Route component={TopHeader} />
              <div className="page-content-wrapper">
                <div className="header-bg">
                  <div className="container-fluid">
                    <div className="row">
                      <div
                        className="col-12 mt-5 mb-4 pt-5 text-center"
                        style={{ height: "65vh" }}
                      >
                        <h2>Welcome to the Dashboard !!!</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Route component={Footer} />
          </div>
        </div>
      </div>
    );
  }
}
export default AdminDashboard;



// WEBPACK FOOTER //
// ./src/component/admin/admindashboard.js